import type { InputHTMLAttributes } from 'react'

export interface SwitchProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'type'
> {
  label?: string
}

export function Switch({ label, checked, style, ...rest }: SwitchProps) {
  return (
    <label
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 10,
        cursor: 'pointer',
        fontSize: 14.5,
        color: 'var(--ink-1)',
        ...style,
      }}
    >
      <span style={{ position: 'relative', display: 'inline-flex' }}>
        <input
          type="checkbox"
          checked={checked}
          style={{ position: 'absolute', opacity: 0, width: 0, height: 0 }}
          {...rest}
        />
        <span
          style={{
            width: 40,
            height: 23,
            borderRadius: 'var(--radius-pill)',
            background: checked ? 'var(--emerald-600)' : 'var(--paper-3)',
            transition: 'background var(--dur-fast) var(--ease-standard)',
            display: 'inline-block',
            position: 'relative',
            flexShrink: 0,
          }}
        >
          <span
            style={{
              position: 'absolute',
              top: 2,
              left: checked ? 19 : 2,
              width: 19,
              height: 19,
              borderRadius: '50%',
              background: '#fff',
              boxShadow: 'var(--shadow-sm)',
              transition: 'left var(--dur-fast) var(--ease-standard)',
            }}
          />
        </span>
      </span>
      {label && <span>{label}</span>}
    </label>
  )
}

export default Switch
